import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'pt-new-group-dialog',
  template: `
    <div class='modal-header'>
      <h4 class='modal-title'>
        {{ title | async }}
      </h4>
    </div>
    <div class='modal-body'>
      <p>
        {{ message | async }}
      </p>
      <form [formGroup]='formGroup'>
        <div class='form-group'>
          <label class="form-label">{{ inputLabel | async }}
            <span class='text-danger'>*</span>
          </label>
          <input
            type='text'
            autocomplete='off'
            formControlName='group'
            class='form-control form-control-sm'
          >
        </div>
      </form>
    </div>

    <div class='modal-footer'>
      <button type='button' class='btn btn-primary btn-sm'
              [disabled]='formGroup?.invalid'
              (click)='confirm()'>
        {{ 'BUTTON.ADD' | translate }}
      </button>
      <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false)'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>
  `
})
export class NewGroupDialogComponent implements OnInit {
  @Input() title: Observable<string>;
  @Input() message: Observable<string>;
  @Input() inputLabel: Observable<string>;

  formGroup: FormGroup;

  constructor(public activeModal: NgbActiveModal) {
  }


  ngOnInit(): void {

    this.formGroup = new FormGroup({
      group: new FormControl(null, [Validators.required])
    });
  }

  confirm() {
    this.activeModal.close(this.formGroup.controls.group.value);
  }
}
